import { Unlink } from 'lucide-react';
import { TASK_SOURCE_LABELS, type TaskUpstream } from '@shared/types/task-sources';
import { StatusBadge } from '@/components/StatusBadge';
import { formatDateTime } from '@/lib/formatters';

/**
 * SF-T-151: a broken link. The task's source refused it to the source's token (403: no access), so it
 * isn't synced or moved there until someone there gives that account access; then the next sync mends
 * it. On the card's flags line and beside the source in the task's toolbar. Null when the link works.
 */
export function BrokenLinkBadge({ upstream, className }: { upstream: Pick<TaskUpstream, 'kind' | 'source_name' | 'unreachable'> | null | undefined; className?: string }) {
  const broken = upstream?.unreachable;
  if (!upstream || !broken) return null;
  const where = TASK_SOURCE_LABELS[upstream.kind];
  const hint = `${where} won't let the factory see this task${broken.reason ? ` ("${broken.reason}")` : ''}, since ${formatDateTime(broken.since, 'short')}. It isn't synced or moved there until the account ${upstream.source_name} connects with can see it again; then the next sync mends the link.`;
  return (
    <StatusBadge size="sm" tone="danger" className={className} data-hint={hint} data-testid="task-broken-link">
      <Unlink aria-hidden />
      Broken link
    </StatusBadge>
  );
}
